<template>
  <AdminLayout>
    <!-- <DashboardCards />

    <div class="w-full">
      <DashboardCharts />
    </div>

    <DashboardRecentUpdates :updates="recentUpdates" :totalTests="1240" /> -->

    <DashboardFiltersBar
      :filters="selectedFilters"
      :questionnaire-options="questionnaireOptions"
      :version-options="versionOptions"
      :companies="availableFilters.companies || []"
      :roles="availableFilters.roles || []"
      @change="handleFilterChange"
      @apply="applyFilters"
      @reset="resetFilters"
    />

    <section class="space-y-6">
      <div v-if="loading" class="space-y-6 print:hidden">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <div
            v-for="n in 4"
            :key="n"
            class="h-[120px] rounded-2xl animate-pulse"
          />
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div class="lg:col-span-2 h-[380px] rounded-2xl animate-pulse" />
          <div class="h-[380px] rounded-2xl animate-pulse" />
        </div>

        <div class="h-[380px] rounded-2xl animate-pulse" />
        <div class="h-[420px] rounded-2xl animate-pulse" />
      </div>

      <div
        v-else-if="error"
        class="rounded-2xl border border-red-200 bg-red-50 p-6 text-red-700 print:hidden"
      >
        <div class="font-semibold">Não foi possível carregar o dashboard.</div>
        <p class="text-sm mt-1">{{ error }}</p>

        <button
          class="mt-4 px-4 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700 transition"
          @click="loadDashboard"
        >
          Tentar novamente
        </button>
      </div>

      <template v-else>
        <DashboardCards
          :cards="overview.cards"
          :summary="
            overview.overview_panel?.summary?.overall_classification?.label
          "
        />

        <DashboardCharts
          :comparison="overview.comparison"
          :overview-panel="overview.overview_panel"
          :monthly-performance="overview.monthly_performance"
          :response-mode="overview.meta?.response_mode"
        />

        <DashboardRecentUpdates
          :recent-updates="overview.recent_updates"
          :response-mode="overview.meta?.response_mode"
        />
      </template>
    </section>
  </AdminLayout>
</template>

<script setup>
import { onMounted } from "vue";
import DashboardCards from "@/components/admin//DashboardCards.vue";
import DashboardRecentUpdates from "@/components/admin/DashboardRecentUpdates.vue";
import DashboardCharts from "@/components/admin/DashboardCharts.vue";
// import { getDashboardOverview } from "@/services/admin/dashboard";
import AdminLayout from "@/layouts/AdminLayout.vue";
import { useDashboardOverview } from "@/composables/admin/useDashboardOverview";
import DashboardFiltersBar from "@/components/admin/DashboardFiltersBar.vue";

const {
  loading,
  error,
  overview,
  availableFilters,
  selectedFilters,
  questionnaireOptions,
  versionOptions,
  loadOverview,
  loadFilters,
  updateFilter,
  setInitialQuestionnaire,
} = useDashboardOverview();

function handleFilterChange({ key, value }) {
  updateFilter(key, value);
}

async function applyFilters() {
  await loadOverview();
}

async function resetFilters() {
  selectedFilters.value = {
    questionnaire_id: questionnaireOptions.value[0]?.value || null,
    questionnaire_version_id: null,
    company_id: null,
    role_id: null,
    channel: null,
    date_start: null,
    date_end: null,
  };

  await loadOverview();
}

onMounted(async () => {
  await loadFilters();
  setInitialQuestionnaire();
  await loadOverview();
});

// async function loadDashboard(params = {}) {
//   loading.value = true;
//   error.value = "";

//   try {
//     const response = await getDashboardOverview(params);

//     overview.value = {
//       ...overview.value,
//       ...response,
//     };
//   } catch (err) {
//     error.value =
//       err?.response?.data?.message ||
//       err?.message ||
//       "Erro inesperado ao buscar os dados.";
//   } finally {
//     loading.value = false;
//   }
// }

// onMounted(async () => {
//   await loadDashboard();
//   await loadOverview();
// });
</script>
